import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import { languageManager } from '../utils/languageManager'

import { Steps } from '../third/intro.js-react';
import '../third/intro.js/introjs.css';

const styles = theme => ({  
    
});

class FwTutorial extends React.Component {

  state = {
    currentTutorialStep: 0,
    showTutorial: false,
  };

  constructor(props) {     
    super(props);    
  }

  componentDidMount() {
    //this.props.regStepsState((newState) => { setTimeout(() => this.setState(newState),1000) } );
    this.props.regStepsState((newState) => { this.setState(newState) } );
  }
  
  onExit = () => {};

  render() {
    const { currentTutorialStep, showTutorial } = this.state;
    const { steps, regStepsParent } = this.props;
    const { classes } = this.props;

    console.log('COCON estado',this.state);
    
    return (
      <React.Fragment>
        {showTutorial && <div>
                          <Steps
                            enabled={true}
                            steps={steps}
                            initialStep={currentTutorialStep}
                            onExit={this.onExit}                            
                            regParent={regStepsParent}
                            options={{
                              //showBullets:false,
                              keyboardNavigation:false,
                              showButtons:false,
                              exitOnOverlayClick:false,
                              exitOnEsc:false,
                            }}
                            rebuild
                          />
                        </div>}
      </React.Fragment>        
    );
  }
}  
  
export default withStyles(styles,{ withTheme: true })(FwTutorial);



// WEBPACK FOOTER //
// ./src/containers/components/FwTutorialComponent.js